module.exports = __webpack_public_path__ + "static/media/logo_cuc2.8448318b.png";